"use strict";
exports.__esModule = true;
exports.isDashboardName = void 0;
var dashboardNames = ["BOLOS", "OLOS\u0000"];
var isDashboardName = function (name) { return dashboardNames.includes(name); };
exports.isDashboardName = isDashboardName;
//# sourceMappingURL=isDashboardName.js.map